import { render } from "./CollectionSearchCriteria.vue?vue&type=template&id=62fcbfa0"
import script from "./CollectionSearchCriteria.vue?vue&type=script&lang=js"
export * from "./CollectionSearchCriteria.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__